import { gql } from '@apollo/client';

export const GET_USER_ACCESS = gql`
  query accesses($user: String!) {
    accesses(user: $user) {
      user {
        email
        role
      },
      site {
        id
        domain
      }
    }
  }
`;

export const CREATE_ACCESS = gql`
  mutation createAccess($user: String!, $site: [String!]!){
    createAccess(input: {
      sites: $site,
      user: $user
    }) {
      site {
        domain
      }
      id
    }
  }
`;
